let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jW2iq")).then(() => parcelRequire('b7eXC'));